import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/** Fetches the active AI persona's avatar (Alma's circular photo). */
export function useAlmaAvatar(): string | null {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      const { data } = await supabase
        .from('ai_personas')
        .select('avatar_url')
        .eq('active', true)
        .order('created_at', { ascending: true })
        .limit(1)
        .maybeSingle();
      setAvatarUrl((data as { avatar_url: string | null } | null)?.avatar_url ?? null);
    })();
  }, []);

  return avatarUrl;
}

export default useAlmaAvatar;
